import React from "react";

const tabs = [
  { id: "overview", label: "Overview" },
  { id: "family", label: "Family" },
  { id: "health", label: "Health" },
  { id: "documents", label: "Documents" },
  { id: "history", label: "History" },
];

const StudentProfileTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: 24,
        borderBottom: "1px solid var(--border, #e5e7eb)",
        paddingTop: 6,
        marginTop: 6,
      }}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;

        return (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              background: "transparent",
              border: "none",
              padding: "10px 2px",
              cursor: "pointer",
              fontSize: ".95rem",
              fontWeight: isActive ? 800 : 600,
              color: isActive
                ? "var(--accent, #6d28d9)"
                : "var(--text-secondary, #6b7280)",
              borderBottom: isActive
                ? "3px solid var(--accent, #6d28d9)"
                : "3px solid transparent",
              transition: "all .15s ease",
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default StudentProfileTabs;